<template>
   <section data-anim-wrap class="pageHeader -type-1">
    <div data-anim-child="fade delay-1" class="pageHeader__image">
  <img
    :src="isMobileDevice
      ? (vars.mobileBackgroundImage || vars.backgroundImage)
      : vars.backgroundImage"
    alt="image"
  />
</div>

  <div class="container">
    <h1 data-anim-child="slide-up delay-1" class="pageHeader__title tw-text-white">{{ vars.titleText }}</h1>

    <div data-anim-child="slide-up delay-2" class="pageHeader-nav">
      <!-- … -->
    </div>
  </div>
</section>

  
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'IntroSection',

  mixins: [ComponentMixin],

  
});
</script>
